/**
 * Environment variable validation and configuration
 *
 * This module validates that all required environment variables are present
 * at build/startup time, preventing runtime errors from missing configuration.
 */

function requireEnv(key: string): string {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(
      `Missing required environment variable: ${key}\n` +
      `Please check your .env file and ensure ${key} is set.`
    );
  }
  return value;
}

function optionalEnv(key: string, defaultValue: string = ''): string {
  return import.meta.env[key] || defaultValue;
}

/**
 * Validated environment configuration
 * Throws an error at import time if required variables are missing
 */
export const ENV = {
  // Supabase Configuration (Required)
  SUPABASE_URL: requireEnv('VITE_SUPABASE_URL'),
  SUPABASE_KEY: requireEnv('VITE_SUPABASE_PUBLISHABLE_KEY'),

  // Optional Configuration
  MODE: optionalEnv('MODE', 'development'),
  DEV: import.meta.env.DEV,
  PROD: import.meta.env.PROD,

  // Feature Flags
  ENABLE_BPM_CONTROL: optionalEnv('VITE_ENABLE_BPM_CONTROL', 'false') === 'true',
} as const;

// Validate on module load
console.log('[ENV] Environment variables validated successfully');

if (ENV.DEV) {
  console.log('[ENV] Running in development mode');
}
